import { render, staticRenderFns } from "./subsidy.vue?vue&type=template&id=59762c08&scoped=true&"
import script from "./subsidy.vue?vue&type=script&lang=js&"
export * from "./subsidy.vue?vue&type=script&lang=js&"
import style0 from "./subsidy.vue?vue&type=style&index=0&id=59762c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59762c08",
  null
  
)

export default component.exports